import React, { Component } from "react";
import { Table, Input, Space, Button } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import locale from "./localeTable";
import './Styles.css';
import EstadosLeyenda from "./EstadosLeyenda";
import ButtonItem from "./ButtonItem";
// import Highlighter from "react-highlight-words";
import moment from "moment";
moment.locale("es");

class TableItem extends Component {
  state = {
    searchText: "",
    searchedColumn: "",
    filters: {},
    sorter: {},
    clearKey: 0,
  };

  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }

  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null);
    }
  }

  clearAllFilters = () => {
    this.setState(prevState => ({
      searchText: "",
      searchedColumn: "",
      filters: {},
      sorter: {},
      clearKey: prevState.clearKey + 1,
    }));

    if (this.props.onClearFilters) {
      this.props.onClearFilters();
    }
  };
  getColumnSearchProps = (dataIndex) => {
    // Soportar búsqueda en múltiples campos
    const searchFields = Array.isArray(dataIndex) ? dataIndex : [dataIndex];

    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              this.searchInput = node;
            }}
            placeholder={`Buscar...`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              this.handleSearch(selectedKeys, confirm, dataIndex)
            }
            style={{ width: 250, marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Buscar
            </Button>
            <Button
              onClick={() => this.handleReset(clearFilters)}
              size="small"
              style={{ width: 90 }}
            >
              Limpiar
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) => {
        // Buscar en todos los campos especificados
        return searchFields.some(field =>
          record[field]
            ? record[field]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
            : false
        );
      },
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      // render: (text) => {
      //   return this.state.searchedColumn === dataIndex ? (
      //     <Highlighter
      //       highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
      //       searchWords={[this.state.searchText]}
      //       autoEscape
      //       textToHighlight={text ? text.toString() : ""}
      //     />
      //   ) : (
      //     text
      //   )},
    };
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // Wrapper para convertir columnas de acción - Usa acciones-container
  wrapActionsColumn = (column) => {
    if (!column.render) return column;

    const originalRender = column.render;

    return {
      ...column,
      render: (value, record, index) => {
        const result = originalRender(value, record, index);

        // Si el resultado es un Space con botones, convertirlo a acciones-container
        if (React.isValidElement(result) && result.type === Space) {
          const buttons = React.Children.toArray(result.props.children).filter(Boolean);

          // Si no hay botones, no mostrar nada
          if (buttons.length === 0) {
            return null;
          }

          // Retornar los botones en el nuevo contenedor
          return (
            <div className="acciones-container">
              {buttons}
            </div>
          );
        }

        return result;
      }
    };
  };

  obtenerClaseVencimiento = (record) => {
    const { estadosLeyenda } = this.props;

    const fechaParaCalcular = record.fechaVencimiento || record.fechaVigencia;

    if (!estadosLeyenda || estadosLeyenda.length === 0 || !fechaParaCalcular) {
      return '';
    }

    const hoy = moment().startOf('day');
    const fechaVigencia = moment(fechaParaCalcular).startOf('day');

    if (fechaVigencia.isSameOrAfter(hoy)) {
      return '';
    }

    const diasVencido = hoy.diff(fechaVigencia, 'days');

    for (let i = 0; i < estadosLeyenda.length; i++) {
      const rango = estadosLeyenda[i];

      if (rango.tope === -1 || diasVencido <= rango.tope) {
        return `rango-vencimiento-${i}`;
      }
    }

    return '';
  };

  render() {
    let columns = this.props.columns.map((value) => {
      let newVal = { ...value };
      if (value.buscar) {
        newVal = { ...value, ...this.getColumnSearchProps(value.buscar) };
      }

      // Aplicar wrapper a columnas de acción/acciones
      if (value.dataIndex === 'accion' || value.dataIndex === 'acciones' || value.key === 'accion' || value.key === 'acciones') {
        newVal = this.wrapActionsColumn(newVal);
      }

      return newVal;
    });
    const isMobile = window.innerWidth <= 1000;
    const hasHeaderContent = (this.props.estadosLeyenda && this.props.estadosLeyenda.length > 0) || this.props.setTextoFiltro || this.props.showClearFilters;
    return (
      <Table
        key={this.state.clearKey}
        className="custom-small-table"
        locale={{ ...locale, ...this.props.locale }}
        onChange={(pagination, filters, sorter) => {
          this.setState({ filters, sorter });
          if (this.props.onChange) {
            this.props.onChange(pagination, filters, sorter);
          }
        }}
        title={hasHeaderContent ? () => (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              padding: "0",
              borderBottom: "none",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                background: "#f5f5f5",
                borderRadius: "6px 6px 0 0",
                padding: "6px 12px",
                boxShadow: "0 -1px 3px rgba(0,0,0,0.1)",
              }}
            >
              {this.props.estadosLeyenda && this.props.estadosLeyenda.length > 0 && (
                <EstadosLeyenda estados={this.props.estadosLeyenda} compact />
              )}
              {this.props.setTextoFiltro && (
                <Input
                  ref={(node) => {
                    this.searchInput = node;
                  }}
                  placeholder="Buscar..."
                  value={this.props.textoFiltro || ""}
                  onChange={(e) => this.props.setTextoFiltro(e.target.value)}
                  style={{ width: 200, marginRight: 8 }}
                  prefix={<SearchOutlined />}
                  size="small"
                />
              )}
              {this.props.showClearFilters && (
                <ButtonItem
                  type="default"
                  size="small"
                  blanco
                  icon={<ClearOutlined />}
                  onClick={() => this.clearAllFilters()}
                >
                  Limpiar Filtros
                </ButtonItem>
              )}
            </div>
          </div>
        ) : undefined}
        columns={columns.map(valueColum => {
          let ellipsis = false
          if (valueColum.dataIndex !== 'accion') ellipsis = true
          // if(valueColum.ellipsis !== undefined) ellipsis = valueColum.ellipsis
          if (valueColum.dataIndex === 'subtotal' || valueColum.dataIndex === 'total' || valueColum.dataIndex === 'saldo' || valueColum.dataIndex === 'costo' || valueColum.dataIndex === 'totalPagar' || valueColum.dataIndex === 'cantidad' || valueColum.dataIndex === 'cargos' || valueColum.dataIndex === 'abonos') {
            return { ...valueColum, ellipsis, align: 'right' }
          } else {
            return { ...valueColum, ellipsis }
          }
        })}
        dataSource={this.props.dataSource}
        rowSelection={this.props.rowSelection}
        onRow={this.props.onRow}
        components={this.props.components}
        loading={this.props.loading}
        size={this.props.size}
        expandable={this.props.expandable}
        rowClassName={this.props.rowClassName ? this.props.rowClassName : (record, index) => {

          const claseVencimiento = this.obtenerClaseVencimiento(record);
          if (claseVencimiento) return claseVencimiento;
          if (record.efo) {
            return 'efo'
          }
          if (record.saldoAFavor) {
            return 'saldoAFavorClassName'
          }
          if (record.revisar) {
            return 'revisar'
          }
          if (record.tieneExtras) {
            return 'tiene-extras'
          }
          if (record.importancia === 3) {
            return 'alta-importancia'
          }
          if (record.importancia === 2) {
            return 'media-importancia'
          }
          if (record.importancia === 1) {
            return 'baja-importancia'
          }
          if (index % 2 === 0) {
            return 'zebra-gris'
          }
          return 'default'
        }}
        rowKey={this.props.rowKey ? this.props.rowKey : (value) => value._id}
        tableLayout='fixed'
        scroll={{ x: isMobile ? "max-content" : undefined, y: '60vh' }}
        pagination={{
          defaultPageSize: this.props.defaultPageSize || 100,
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} elementos`,
        }}
        summary={this.props.summary}
      />
    );
  }
}

TableItem.Summary = Table.Summary;

export default TableItem;
